import type { UiConfig } from '../config/ui.config';
import { el } from './dom';
import { ICONS, icon } from './icons';
import { closeOnBackdrop, menuButton, menuFooter, menuLink } from './MenuParts';

/** What an account brings – shown as a ticked list. */
const BENEFITS = [
  'Dein Name in der Bestenliste',
  'Um Preise mitspielen – startet in Kürze',
  'Ein Konto für das Spiel und ructec.com',
] as const;

/**
 * Sign-up page (opened from the start screen). Registration and login run on ructec.com. Registering opens a new tab;
 * signing in opens the portal's /spiel-anmelden in this tab, which sends the player back with a Spielausweis for the
 * leaderboard (ructec 2026-10-08).
 */
export class RegisterScreen {
  readonly element: HTMLDivElement;

  constructor(parent: HTMLElement, ui: UiConfig, onBack: () => void) {
    this.element = el('div', 'screen menu menu-sub menu-register', undefined, parent);
    const panel = el('section', 'sub-panel', undefined, this.element);
    panel.setAttribute('aria-labelledby', 'register-title');
    const title = el('h2', 'sub-title', undefined, panel);
    title.id = 'register-title';
    title.append(icon(ICONS.account, 'sub-title-icon'), 'Registrieren & mitspielen');
    const list = el('ul', 'sub-benefits', undefined, panel);
    for (const text of BENEFITS) {
      const item = el('li', undefined, undefined, list);
      item.append(icon(ICONS.advantage, 'sub-benefit-icon'));
      el('span', undefined, text, item);
    }
    const actions = el('div', 'sub-actions', undefined, panel);
    menuLink(actions, 'Jetzt registrieren', ui.account.registerUrl, 'is-primary');
    const login = menuLink(actions, 'Schon registriert? Anmelden', ui.account.loginUrl, 'is-secondary');
    login.target = '_self'; // back into the game with the Spielausweis
    login.removeAttribute('rel');
    menuButton(actions, 'Zurück', onBack, 'is-secondary');
    el('p', 'sub-note', 'Registrierung und Anmeldung laufen über ructec.com.', panel);
    menuFooter(this.element, ui.footer);
    closeOnBackdrop(this.element, onBack);
  }
}
